export const siteConstants = {
 
    ADD_SITE_REQUEST: 'ADD_SITE_REQUEST',
    ADD_SITE_SUCCESS: 'ADD_SITE_SUCCESS',
    ADD_SITE_FAILURE: 'ADD_SITE_FAILURE',

    CHECK_USERNAME_REQUEST: 'FETCH_USERNAME_REQUEST',
    CHECK_USERNAME_SUCCESS: 'FETCH_USERNAME_SUCCESS',
    CHECK_USERNAME_FAILURE: 'FETCH_USERNAME_FAILURE',

    CHECK_SITENAME_REQUEST: 'FETCH_SITENAME_REQUEST',
    CHECK_SITENAME_SUCCESS: 'FETCH_SITENAME_SUCCESS',
    CHECK_SITENAME_FAILURE: 'FETCH_SITENAME_FAILURE',

    CHECK_SITENAME_REQUEST: 'CHECK_SITENAME_REQUEST',
    CHECK_SITENAME_SUCCESS: 'CHECK_SITENAME_SUCCESS',
    CHECK_SITENAME_FAILURE: 'CHECK_SITENAME_FAILURE',

    CHECK_USER_EMAIL_REQUEST:'CHECK_USER_EMAIL_REQUEST',
    CHECK_USER_EMAIL_SUCCESS:'CHECK_USER_EMAIL_SUCCESS',
    CHECK_USER_EMAIL_FAILURE:'CHECK_USER_EMAIL_FAILURE',

    VIEW_SITELIST_REQUEST:'VIEW_SITELIST_REQUEST',
    VIEW_SITELIST_SUCCESS:'VIEW_SITELIST_SUCCESS',
    VIEW_SITELIST_FAILURE:'VIEW_SITELIST_FAILURE',

    VIEW_SITEPAIDLIST_REQUEST:'VIEW_SITEPAIDLIST_REQUEST',
    VIEW_SITEPAIDLIST_SUCCESS:'VIEW_SITEPAIDLIST_SUCCESS',
    VIEW_SITEPAIDLIST_FAILURE:'VIEW_SITEPAIDLIST_FAILURE',

    VIEW_SITEDATABYID_REQUEST:'VIEW_SITEDATABYID_REQUEST',
    VIEW_SITEDATABYID_SUCCESS:'VIEW_SITEDATABYID_SUCCESS',
    VIEW_SITEDATABYID_FAILURE:'VIEW_SITEDATABYID_FAILURE',

    UPDATE_SITE_REQUEST:'UPDATE_SITE_REQUEST',
    UPDATE_SITE_SUCCESS: 'UPDATE_SITE_SUCCESS',
    UPDATE_SITE_FAILURE: 'UPDATE_SITE_FAILURE',

    DELETE_SITE_REQUEST:'DELETE_SITE_REQUEST',
    DELETE_SITE_SUCCESS:'DELETE_SITE_SUCCESS',
    DELETE_SITE_FAILURE:'DELETE_SITE_FAILURE',

    UPDATE_SITE_STATUS_REQUEST:'UPDATE_SITE_STATUS_REQUEST',
    UPDATE_SITE_STATUS_SUCCESS:'UPDATE_SITE_STATUS_SUCCESS',
    UPDATE_SITE_STATUS_FAILURE:'UPDATE_SITE_STATUS_FAILURE',
   
    CHECK_SITEDOMAIN_REQUEST: 'CHECK_SITEDOMAIN_REQUEST',
    CHECK_SITEDOMAIN_SUCCESS: 'CHECK_SITEDOMAIN_SUCCESS',
    CHECK_SITEDOMAIN_FAILURE: 'CHECK_SITEDOMAIN_FAILURE',

    GET_CITY_GEOLOCATION_REQUEST:'GET_CITY_GEOLOCATION_REQUEST',
    GET_CITY_GEOLOCATION_SUCCESS:'GET_CITY_GEOLOCATION_SUCCESS',
    GET_CITY_GEOLOCATION_FAILURE:'GET_CITY_GEOLOCATION_FAILURE',

    GET_DASHBOARD_DETAILS_REQUEST: 'GET_DASHBOARD_DETAILS_REQUEST',
    GET_DASHBOARD_DETAILS_SUCCESS: 'GET_DASHBOARD_DETAILS_SUCCESS',
    GET_DASHBOARD_DETAILS_FAILURE: 'GET_DASHBOARD_DETAILS_FAILURE',


    GET_PAIDDASHBOARD_DETAILS_REQUEST: 'GET_PAIDDASHBOARD_DETAILS_REQUEST',
    GET_PAIDDASHBOARD_DETAILS_SUCCESS: 'GET_PAIDDASHBOARD_DETAILS_SUCCESS',
    GET_PAIDDASHBOARD_DETAILS_FAILURE: 'GET_PAIDDASHBOARD_DETAILS_FAILURE',


    GET_CUSTOMER_DATA_REQUEST: 'GET_CUSTOMER_DATA_REQUEST',
    GET_CUSTOMER_DATA_SUCCESS: 'GET_CUSTOMER_DATA_SUCCESS',
    GET_CUSTOMER_DATA_FAILURE: 'GET_CUSTOMER_DATA_FAILURE',
    SEND_SUBDOMAIN_REQUEST: 'SEND_SUBDOMAIN_REQUEST',
    SEND_SUBDOMAIN_SUCCESS: 'SEND_SUBDOMAIN_SUCCESS',
    SEND_SUBDOMAIN_FAILURE: 'SEND_SUBDOMAIN_FAILURE',
    SEND_SUBDOMAINLIST_REQUEST: 'SEND_SUBDOMAINLIST_REQUEST',
    SEND_SUBDOMAINLIST_SUCCESS: 'SEND_SUBDOMAINLIST_SUCCESS',
    SEND_SUBDOMAINLIST_FAILURE: 'SEND_SUBDOMAINLIST_FAILURE',
    SEND_SSL_REQUEST: 'SEND_SSL_REQUEST',
    SEND_SSL_SUCCESS: 'SEND_SSL_SUCCESS',
    SEND_SSL_FAILURE: 'SEND_SSL_FAILURE',
};


// WEBPACK FOOTER //
// ./src/app/redux/constants/siteConstants.js